/** GENERATED_ASSET — bounds helpers ported from the batch001 static kit (`static-kit/source/geometry.ts`). */
import type { Point2, VisualBounds } from './contracts';

/** Axis-aligned bounds of the points, grown by `pad` on every side. */
export function box(points: readonly Point2[], pad = 0): VisualBounds {
  if (!points.length || !points.every((p) => Number.isFinite(p.x) && Number.isFinite(p.y))) {
    throw new Error('invalid bound points');
  }
  const x = Math.min(...points.map((p) => p.x)) - pad;
  const y = Math.min(...points.map((p) => p.y)) - pad;
  return {
    x,
    y,
    width: Math.max(...points.map((p) => p.x)) + pad - x,
    height: Math.max(...points.map((p) => p.y)) + pad - y,
  };
}

export function corners(b: VisualBounds): Point2[] {
  return [
    { x: b.x, y: b.y },
    { x: b.x + b.width, y: b.y },
    { x: b.x, y: b.y + b.height },
    { x: b.x + b.width, y: b.y + b.height },
  ];
}

export function expand(b: VisualBounds, p: number): VisualBounds {
  return { x: b.x - p, y: b.y - p, width: b.width + 2 * p, height: b.height + 2 * p };
}

export function union(b: readonly VisualBounds[]): VisualBounds {
  return box(b.flatMap(corners));
}

/** Key-sorted, finite-only canonical JSON used for logical recipe identity. */
export function canonical(v: unknown): string {
  if (v === null) return 'null';
  if (typeof v === 'number' && !Number.isFinite(v)) throw new Error('nonfinite identity');
  if (typeof v === 'number' || typeof v === 'boolean' || typeof v === 'string') return JSON.stringify(v);
  if (Array.isArray(v)) return `[${v.map(canonical).join(',')}]`;
  if (!v || typeof v !== 'object') throw new Error('unsupported canonical value');
  const r = v as Record<string, unknown>;
  return `{${Object.keys(r).sort().map((k) => `${JSON.stringify(k)}:${canonical(r[k])}`).join(',')}}`;
}
